module.exports = __webpack_public_path__ + "static/media/rightArrow.13d10cb6.png";